import type {RgbCurveSockets} from "#material/nodes/color/rgb-curve/definition"
import type {MaterialNodeParameters, MaterialNodeSettings} from "#material/sockets/parameters"
import type {Version} from "@cm/graph-v3"

type Current = MaterialNodeParameters<RgbCurveSockets>
type WithCurveExtends = Omit<Current, "settings"> & {settings: MaterialNodeSettings<RgbCurveSockets> & Partial<Record<`mappingCurves_${number}Extend`, string>>}
type WithDisabled = Omit<WithCurveExtends, "settings"> & {settings: WithCurveExtends["settings"] & {disabled?: boolean}}

/** Muting a node is ui.disabled, which every renderer reads and the exchange format carries as internal.mute. */
export const dropDisabledNoRendererReads: Version<WithDisabled, WithCurveExtends> = {
    toNextVersion: ({settings: {disabled, ...settings} = {}, ...parameters}) => ({...parameters, settings}),
}

const isCurveExtend = (key: string) => /^mappingCurves_\d+Extend$/.test(key)

/** Blender 2.8 replaced the extend of each curve with one for the whole mapping, extrapolated when any curve was. */
export const foldCurveExtendsIntoMapping: Version<WithCurveExtends, Current> = {
    toNextVersion: ({settings: allSettings = {}, ...parameters}) => {
        const curveExtends = Object.entries(allSettings).flatMap(([key, value]) => (isCurveExtend(key) ? [value] : []))
        const settings = Object.fromEntries(Object.entries(allSettings).filter(([key]) => !isCurveExtend(key))) as Current["settings"]
        if (curveExtends.length === 0 || settings.mappingExtend !== undefined) return {...parameters, settings}
        return {...parameters, settings: {...settings, mappingExtend: curveExtends.includes("EXTRAPOLATED") ? "EXTRAPOLATED" : "HORIZONTAL"}}
    },
}
